<template>
  <div>    
    <div v-if="this.tokenStatus == 0" class="container-fluid p-3 p-md-4 mb-5">
        <div class="row justify-content-center">
            <div class="col-12 col-lg-10 col-xl-8">
                <div class="bg-white rounded-1 shadow-lg overflow-hidden position-relative">
                    <div class="bg-gradient-primary py-5 text-center text-gray-800 position-relative overflow-hidden pulse-animation">
                        <div class="position-relative" style="z-index: 1;">
                            <h1 class="display-4 fw-normal mb-1">
                                <i class="bi bi-shield-lock me-3 fs-3x text-gray-800"></i> {{ $t('gdpr_consent') }} 
                            </h1>
                            <p class="lead mb-0" v-if="releaseDate">Release Date: ({{previewDate(releaseDate)}}) </p>
                            <p class="lead mb-0"> {{ $t('your_privacy_matters_to') }} </p>
                        </div>
                    </div>
                    <div class="p-4 p-md-5">     
                      <div class="bg-light p-4 mb-4 rounded-3 overflow-auto" style="max-height: 500px; line-height: 1.8;">                   
                        <div ref="documentToDownload" v-html="agreementContent"></div>
                      </div>
                      <div class="bg-light bg-opacity-50 border border-gray-300 shadow border-2 rounded-3 p-4 text-gray-800">
                          <h2 class="h4 mb-3">
                             {{ $t('your_consent') }} 
                          </h2>
                          <p class="mb-4">
                               {{ $t('please_review_the_gdpr') }} 
                          </p>
                          
                          <div class="row g-3 mb-4">
                              <div class="col-lg-12">
                                  <div class="consent-option p-3 d-flex align-items-start bg-white border border-1 rounded-3 border-secondary" :class="{'border-success': approvalStatus == 'accept' }"
                                    @click="selectOption('accept')">
                                    <div class="form-check form-check-success form-check-inline">
                                        <input class="form-check-input my-3" type="radio" name="approvalStatus" id="inlineRadio1" value="accept" v-model="approvalStatus">
                                        <label class="form-check-label ms-3" for="inlineRadio1">
                                          <div class="fw-bold text-success mb-1 fs-5">
                                             {{ $t('i_accept') }} 
                                          </div>
                                          <p class="text-gray-800">
                                               {{ $t('i_have_read_and') }} 
                                          </p>
                                        </label>
                                    </div>
                                  </div>
                              </div>
                              <div class="col-lg-12">
                                  <div class="consent-option p-3 d-flex align-items-start bg-white border border-1 rounded-3 border-secondary" :class="{'border-danger': approvalStatus == 'decline' }"
                                    @click="selectOption('decline')">
                                    <div class="form-check form-check-danger form-check-inline">
                                        <input class="form-check-input my-3" type="radio" name="approvalStatus2" id="inlineRadio2" value="decline" v-model="approvalStatus">
                                        <label class="form-check-label ms-3" for="inlineRadio2">
                                          <div class="fw-bold text-danger mb-1 fs-5">
                                             {{ $t('i_decline') }} 
                                          </div>
                                          <p class="text-gray-800">
                                               {{ $t('i_do_not_consent') }} 
                                          </p>
                                        </label>
                                    </div>
                                  </div>
                              </div>
                          </div>
                          
                          <div class="text-center">
                              <button class="btn btn-consent btn-lg text-gray-800 fw-bold px-5 py-3 bg-gradient-success border-0 rounded-pill shadow position-relative overflow-hidden" id="submitButton" @click="submitConsent()" :disabled="approvalStatus == null" :class="{'border-danger': approvalStatus == 'decline' }">
                                  <i class="bi bi-send me-2"></i> {{ $t('submit_my_choice') }} 
                              </button>
                          </div>
                          
                          <div class="success-message p-4 mt-4 text-center d-none text-gray-800 rounded-3 bg-gradient-success" id="successMessage">
                              <h3 class="h5 mb-2">
                                  <i class="bi bi-check-circle-fill me-2"></i> {{ $t('thank_you') }} 
                              </h3>
                              <p class="mb-0"> {{ $t('your_consent') }} </p>
                          </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-if="this.tokenStatus == 1 || this.tokenStatus == 2" class="d-flex flex-column flex-center text-center p-10">        
      <div class="card card-flush w-lg-650px py-5">
        <div class="card-body py-15 py-lg-20">
          <h1 class="fw-bolder fs-2hx text-gray-900 mb-4">
            <span v-if="tokenStatus == 1"> {{ $t('url_is_invalid') }} </span>  
            <span v-if="tokenStatus == 2"> {{ $t('token_expired') }} </span>  
          </h1>
          <div class="fw-semibold fs-6 text-gray-500 mb-8">
             {{ $t('to_receive_a_new') }}  <a href="mailto:support@creatorcube.uk">support@creatorcube.uk</a>
          </div>
          <div class="mb-10">
            <img v-if="tokenStatus == 1" src="assets/theme/media/illustrations/unitedpalms-1/18.png" class="mw-100 mh-200px theme-light-show" alt="">
            <img v-if="tokenStatus == 2" src="assets/theme/media/illustrations/unitedpalms-1/5.png" class="mw-100 mh-200px theme-light-show" alt="">
            
            <img v-if="tokenStatus == 1" src="assets/theme/media/illustrations/unitedpalms-1/18-dark.png" class="mw-100 mh-200px theme-dark-show" alt="">
            <img v-if="tokenStatus == 2" src="assets/theme/media/illustrations/unitedpalms-1/5-dark.png" class="mw-100 mh-200px theme-dark-show" alt="">
          </div>
          <div class="mb-10 fw-semibold fs-6 text-gray-500">
            <router-link to="/Login">
              <a href="#" class="btn btn-primary fw-bold">
                 {{ $t('back_to_login') }} 
              </a>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div v-if="this.tokenStatus == 3" class="d-flex flex-column flex-center text-center p-10">        
      <div class="card card-flush w-lg-650px py-5">
        <div class="card-body py-15 py-lg-20">
          <h1 class="fw-bolder fs-2hx text-gray-900 mb-4">
            ✅ {{ $t('thank_you') }} 
          </h1>
          <div class="fw-semibold fs-6 text-gray-500 mb-8">
             {{ $t('your_consent_preference_has') }} 
          </div>
          <div class="mb-10">
              <img src="assets/theme/media/illustrations/unitedpalms-1/4.png" class="mw-100 mh-200px theme-light-show" alt="">
              <img src="assets/theme/media/illustrations/unitedpalms-1/4-dark.png" class="mw-100 mh-200px theme-dark-show" alt="">
          </div>
          
          <div class="d-flex flex-center pb-20">
            <router-link to="/Login">
              <a href="#" class="btn btn-lg btn-primary">
                 {{ $t('login') }} 
              </a>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from 'moment';
export default {
  name: "Approval",
  data() {
    return {
      tokenStatus: -1,
      tokenType: 0,
      isHide: true,
      verificationType: this.$route.query.type,
      userName: null,
      isProggressing: false,
      agreementContent: null,
      approvalStatus: null,
      releaseDate: null
    };
  },
  computed: {
    previewDate(){
      return (value)=>{
       if (value) {
          return moment(new Date(value)).format('DD.MM.YYYY')
        }
      }
    },
  },
  methods: {
    getData(){
      
      document.body.style.backgroundImage = "url('/assets/theme/media/auth/bg7-dark.jpg')";
      document.body.classList.add('app-blank');
      document.body.classList.add('bgi-size-cover');
      document.body.classList.add('bgi-position-center');
      document.body.classList.add('bgi-no-repeat');
      if(!this.$route.query.code) {return this.$router.push({ name: 'Login' });}

      const parameters = {
        code: this.$route.query.code,
        type: 4 /* Content Approval */
      };
      axios.post('/api/Auth/CheckTokenExpired', parameters, {'Content-Type': 'application/json'})
      .then((response) => {
        if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
          this.tokenStatus = response.data.tokenStatus;
          this.userName = response.data.name_surname;
          this.agreementContent = response.data.agreement_content;
          this.releaseDate = response.data.release_date;
        }
      })
      .catch((error) => {
        console.error(error);
      });
    },
    selectOption(option) {
      this.approvalStatus = option;
    },
    submitConsent() {
      this.$swal.fire({
        title: this.$t('are_you_sure_you_want_to_approve_gdpr_consent'),
        confirmButtonColor: "#50cd89",
        showDenyButton: false,
        showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
        confirmButtonText: this.$t('save'),
        icon: 'info'
      })
      .then((result) => {
        if (result.isConfirmed) {
          this.isProggressing = true;
          const parameters = {
            channel: "User Approval Page",
            token: this.$route.query.code,
            is_approved: this.approvalStatus == 'accept' ? 1 : 0,
            operation: "GDPR Consent" + (this.approvalStatus == 'accept' ? " approved." : " declined.")
          };  
          const that = this;
          axios.post('/api/Notification/ApproveConsent', parameters, {'Content-Type': 'application/json'})
          .then((response) => {
            if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
              this.tokenStatus = 3;
              setTimeout(() => {
                this.$signOutWithTimer(this.$t('thank_you'), this.$t('your-consent-preference-has-been-successfully-reco'));
              }, 1000);
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => { 
              setTimeout(() => {
                that.isProggressing = false;
              }, 500);
          });  
        }
      });
    }
  },
  created() {
     this.getData();
  }
};
</script>